// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2MZa5","head":"ProcedureTableInfo_head__1_Ozj"};